import { Component } from '@angular/core';

@Component({
  selector: 'app-cgu-loyalty-fr',
  templateUrl: './cgu-loyalty-fr.component.html',
  styleUrls: ['./cgu-loyalty-fr.component.scss'],
  standalone: false,
})
export class CguLoyaltyFrComponent {}
